import * as React from "react"
import { Link, graphql } from "gatsby"
import Image from 'gatsby-image';

import Layout from "../components/layoutIndex"
import Seo from "../components/seo"

const BlogIndex = ({ data, location, pageContext }) => {
  const commonCap = data.allDataYaml.edges[0].node.caption.common
  const rawPosts = data.allMarkdownRemark.nodes
  let { language } = pageContext
  let posts = []

  if (language === undefined || language === null) {
    language = 'ja'

    rawPosts.forEach(element => {
      if (element['fields']["language"] === language) {
        posts.push(element)
      }
    })
  } else {
    posts = rawPosts
  }

  if (posts.length === 0) {
    return (
      <Layout location={location} title={commonCap[language]["site_title"]} language={language}>
        <p>
          No blog posts found.
        </p>
      </Layout>
    )
  }

  return (
    <Layout location={location} title={commonCap[language]["site_title"]} language={language}>
      <ol style={{ listStyle: `none` }} className="post-list">
        {posts.map((post,index) => {
          const title = post.frontmatter.title || post.fields.slug

          return (
            <li key={index}>
              <article
                className="post-list-item"
                itemScope
                itemType="https://schema.org/Article"
              >
                <Link to={`/${language}/${post.fields.category}/${post.fields.slug}`} itemProp="url">
                  <Image
                    fluid={post.frontmatter.hero.childImageSharp.fluid}
                    className="post-list-thumbnail"/>
                  <header>
                    <h4>
                        <span itemProp="headline">{title}</span>
                    </h4>
                    <small>{post.frontmatter.date}</small>
                  </header>
                </Link>
              </article>
            </li>
          )
        })}
      </ol>
    </Layout>
  )
}

export default BlogIndex

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = ({ pageContext, location }) => {
  let language = pageContext.language
  if (language === undefined || language === null) {
    language = 'ja'
  }
  return <>
    <link rel="alternate" hrefLang={language} href={location.pathname} />
    <Seo language={language} location={location} />
  </>
}

export const pageQuery = graphql`
  query IndexPostByLang (
    $language: String
  )
  {
    site {
      siteMetadata {
        title
      }
    }
    allDataYaml {
      edges {
        node {
          caption {
            common {
              ja {
                site_title
                privacy
                contact
              }
              en {
                site_title
                privacy
                contact
              }
            }
          }
        }
      }
    }
    allMarkdownRemark(
      sort: { frontmatter: { date: DESC } },
      filter: {fileAbsolutePath: { regex: "/post/" }, fields: { language: { eq: $language }}},
      ) {
      nodes {
        excerpt(pruneLength: 100)
        fields {
          slug
          category
          language
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          hero {
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
